<template>
  <b-container class="subscribe" fluid>
    <b-row class="p-4">
      <b-col class="mx-auto p-4 divider-left my-4" lg="6">
        <div class="text-center dec-width m-auto">
          <span class="h4 font-weight-bold">¡Déjanos tu Correo!</span><br />
          <p class="mx-auto text-center dec-width" v-if="route !== 'eureka'">
            Te escribiremos con el valor del servicio y sus detalles, y te
            preparamos una cotización a la medida de tu establecimiento.
            <template v-if="esSistemaPie">
              ¿Cuántos estudiantes tienes en PIE? Con ese dato te calculamos el
              valor exacto para tu establecimiento.
            </template>
          </p>
          <p class="mx-auto text-center dec-width" v-if="route === 'eureka'">
            Te enviaremos una cotización y los detalles del servicio
          </p>
          <b-form @submit.prevent="requestEmail">
            <b-row class="mx-auto no-gutters">
              <b-col class="mt-2" :lg="esSistemaPie ? 5 : 7">
                <b-input
                  v-model="email"
                  class="form-control rounded-pill"
                  placeholder="correo@ejemplo.cl"
                  type="email"
                  name="email"
                  required
                ></b-input>
              </b-col>
              <!--
                Opcional a propósito: sin el número igual queda el contacto, y
                con él la persona recibe la cotización armada con el precio de
                BusinessProduct y el tope por colegio. Para nosotros además
                dice si el establecimiento está sobre o bajo el tope, que es la
                diferencia entre un trato de $600.000 y uno de $3.000.000.
              -->
              <b-col class="mt-2" lg="4" v-if="esSistemaPie">
                <b-input
                  v-model="students"
                  class="form-control rounded-pill"
                  placeholder="N° de estudiantes PIE"
                  type="number"
                  min="1"
                  name="students"
                ></b-input>
              </b-col>
              <b-col class="mt-2" :lg="esSistemaPie ? 3 : 5">
                <b-button
                  class="rounded-pill font-weight-bold"
                  type="submit"
                  variant="danger"
                >
                  Solicitar Envío
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-col>
      <b-col class="mx-auto p-4 my-4" lg="6">
        <div class="dec-width text-center m-auto">
          <span class="h4 font-weight-bold"
            >También puedes comunicarte directamente</span
          >
          <b-row class="mx-auto p-2" v-show="false">
            <b-button
              class="mx-auto rounded-pill mt-2 text-light font-weight-bold"
              variant="warning"
              >Descargar Cotización
            </b-button>
            <b-button
              class="mx-auto rounded-pill mt-2 text-light font-weight-bold"
              variant="warning"
              >Descargar Contrato
            </b-button>
          </b-row>
          <p class="dec-width mx-auto h6 mt-3">
            Háblanos a <b>contacto@redpie.cl</b> y llamando al
            <b>+569 5 066 41 86</b> o al <b>+569 9 223 88 89</b>
          </p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import redpieService from "@/services/redpieService";
import informationService from "@/services/informationService";

// Cada página de venta cotiza su propio producto, y la clave es el código de
// BusinessProduct: de ahí sale el precio que cobra el generador. Las otras dos
// páginas (eureka, planification) entran agregando una línea acá.
const PRODUCTO_POR_PAGINA = {
  redpie: "PIE",
};

export default {
  name: "Subscribe",
  props: {
    route: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      email: "",
      students: "",
    };
  },
  computed: {
    producto() {
      return PRODUCTO_POR_PAGINA[this.route] || null;
    },
    esSistemaPie() {
      return this.producto === "PIE";
    },
  },
  methods: {
    // Con la cantidad se pide la cotización de verdad, que es la misma que
    // entrega el chat de /#/pie-demo: el backend arma el documento con el
    // precio de BusinessProduct y el tope por colegio. Sin ella sale el correo
    // con el valor de lista, para no perder a quien no tiene la cifra a mano.
    requestEmail() {
      const cantidad = parseInt(this.students, 10);
      if (this.producto && cantidad > 0) {
        return this.pedirCotizacion(cantidad);
      }
      return this.pedirDetalles();
    },
    pedirCotizacion(cantidad) {
      return informationService
        .sendEurekaBill({
          email: this.email,
          applications: cantidad,
          service: this.producto,
        })
        .then((response) => {
          this.$toasted.success(response.message);
          this.limpiar();
        })
        .catch(this.avisarDelError);
    },
    pedirDetalles() {
      return redpieService
        .requestSalesEmail({ email: this.email, service: this.route })
        .then((response) => {
          this.$toasted.success(response);
          this.limpiar();
        })
        .catch(this.avisarDelError);
    },
    avisarDelError(error) {
      console.log(error);
      this.$toasted.error("Ocurrió un error. Intenta nuevamente.");
    },
    limpiar() {
      this.email = "";
      this.students = "";
    },
  },
};
</script>

<style scoped>
.subscribe {
  background-image: url("~@/assets/img/sales/subscribe.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #e6f1f3;
}

@media (min-width: 992px) {
  .divider-left {
    border-right: 2px solid #333;
  }

  .dec-width {
    width: 75%;
  }
}
</style>
